
import { ProjectView } from "@/views/project-view";
import { Component, Inject } from "vue-property-decorator";

@Component
export default class extends ProjectView {
    /// private helpers
    get infRead() {
        return require("raw-loader!./interfaces/log.read.interface").default;
    }

    get serverR() {
        return {
            path: "/log",
            params: {
                orderBy: [
                    {
                        createdAt: "desc",
                    },
                ],
            },
        };
    }

    owner(row) {
        return (row?.relation ? JSON.parse(row.relation).owner : null) ?? null;
    }

    getContext(attrs) {
        const { context } = attrs.row;
        if (!context) return context ?? "";

        const regex = /Controller$/;
        if (!regex.test(context)) return context ?? "";
        const quickName = context.replace(regex, "");

        const quick = this.quicks()[quickName];
        if (!quick) return context ?? "";
        const clientPath = quick.clientPath ?? quick.path;

        return { quick, clientPath };
    }

    getAction(attrs) {
        const { action } = attrs.row;
        if (action == null) return action;

        const map = {
            PUT: "修改",
            PATCH: "檢視",
            POST: "新增",
            DELETE: "刪除",
        };
        const key = action.split(" ")[0];
        const result = map[key] ?? action;

        return result;
    }
}
